import { FC, SyntheticEvent } from 'react';
import { RadioGroup } from '@atlaskit/radio';


interface SolicitacaoFoiAtendidaFieldProps {
  valorInicial?: boolean;
  onChange: (atendida: boolean) => void;
}

export const SolicitacaoFoiAtendidaField: FC<SolicitacaoFoiAtendidaFieldProps> = ({onChange, valorInicial}) => {
  const onAtendida = (it: SyntheticEvent<HTMLInputElement>) => {
    onChange(it.currentTarget.value === 'sim');
  }

  const itens = [
    {name: "atendeu", value: "sim", label: "Sim"},
    {name: "atendeu", value: "nao", label: "Não"}
  ];

  const defaultValue = valorInicial === true
    ? "sim" 
    : valorInicial === false
    ? "nao"
    : undefined;

  return <fieldset>
    <legend className="label">Sua solicitação foi atendida?</legend>
    <RadioGroup
      defaultValue={defaultValue}
      options={itens}
      onChange={onAtendida}
      isRequired={true}
    />
  </fieldset>
}